import { useNosIdMutation } from '@/hooks/api/base.hooks';
import { api } from '@/portal-api.definition';
import { ActionType, useI18n, useToast } from '@nosinovacao/nosid-mfe-common';
import { profilesQueryOptions } from '@/hooks/api';
import { useQueryClient } from '@tanstack/react-query';
import { type ProfileForm } from '../../-model/profile-form';

export function useCreateProfile() {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { t } = useI18n();
  return useNosIdMutation({
    mutationFn: ({ profile, sa }: { profile: ProfileForm; sa: string }) => {
      return api.post('api/v1/profiles', {
        Type: profile.type,
        Avatar: profile.avatar ?? undefined,
        ContentRatingLimit: profile.type === 'Kids' ? (profile.ageRating ?? '') : 'Todos',
        Nickname: profile.name,
        DisplayName: profile.name,
        Pin: profile.hasPin && profile.type !== 'Kids' ? (profile.pin ?? undefined) : undefined,
        ServiceAccount: sa,
      });
    },
    errorLogAction: () => ({ ActionType: ActionType.Submit }),
    successLogAction: () => ({ ActionType: ActionType.Submit }),
    onSuccess: (newProfile, { sa }) => {
      queryClient.setQueryData(profilesQueryOptions(sa).queryKey, (old) => {
        const oldProfiles = old ?? [];
        return [...oldProfiles, newProfile];
      });
      toast.show('success', t('Common.SnackBar.ProfileCreated'));
    },
  });
}
